<template>
  <a class="wrapper" :href="`https://www.infoq.cn/article/${data.uuid}`" target="_blank" :style="{ background: `url(${ data.article_cover }) center / cover no-repeat` }">
    <div class="info" :class="{ 'has-summary': data.article_summary }">
      <h2 class="info-title" v-if="data.article_title">{{ data.article_title }}</h2>
      <p class="info-summary" v-if="data.article_summary && config.hasSummary">{{ data.article_summary }}</p>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      default: () => ({
        hasSummary: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/style/variable.sass';

$padding: 16px;

.wrapper {
  display: block;
  position: relative;
  width: 100%; height: 100%;
  box-shadow: 0px 4px 8px 0px rgba(7, 17, 27, 0.1);
  transition: all 0.3s linear;

  @include mobile {
    position: absolute; top: 0; left: 0; bottom: 0; right: 0;
  }

  &:hover {
    // box-shadow: 0px 8px 16px 0px rgba(7, 17, 27, 0.2);
    box-shadow: 0 5px 15px 1px rgba(0,0,0, 0.4);
  }

  & .info {
    position: absolute; left: 0; right: 0; bottom: 0;
    padding: $padding;
    padding-top: 30px;
    padding-bottom: 12px;
    background: linear-gradient(rgba(#000, 0), rgba(#000, 1));
    & .info-title {
      color: #fff;
      font-size: 17px; font-weight: 500;
      line-height: 22px;
      @include limit-line-numbers(1);
    }
    & .info-summary {
      margin-top: 1px;
      color: rgba(#fff, 0.7);
      font-size: 14px;
      @include limit-line-numbers(2);
    }
  }
}
</style>
